import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface ISectionListingModel extends IModel {
  sectionId: number;
  name: string;
  displayName: string;
  sortOrder: number;
}

export class SectionListingModel
  extends Model
  implements ModelRecord<ISectionListingModel>
{
  sectionId: number;
  name: string;
  displayName: string;
  sortOrder: number;

  constructor(params?: Partial<ISectionListingModel>) {
    super(params);
    this.sectionId = defaultTo(params?.sectionId, 0);
    this.name = defaultTo(params?.name, '');
    this.displayName = defaultTo(params?.displayName, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
  }
}
